import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAccordion, LazyAccountsForm, LazyAppointmentsCustomerDetails, LazyAppointmentsDateTime, LazyCalendarDay, LazyCalendarWeek, LazyChartsBar, LazyChartsIncomesBar, LazyChartsIncomesLine, LazyChartsLine, LazyChartsPie, LazyClassCalendarsShow, LazyClassSubscriptionsForm, LazyClassTypesForm, LazyCompletionBar, LazyCustomersAlertBadges, LazyCustomersFormInfo, LazyCustomersFormLongTermAppointments, LazyCustomersFormSubscriptions, LazyCustomersMonth, LazyCustomersYear, LazyFlash, LazyFormColorPickerAlpha, LazyFormColorPickerCheckboard, LazyFormColorPickerClamp, LazyFormColorPickerColor, LazyFormColorPickerCore, LazyFormColorPickerEditInput, LazyFormColorPickerHue, LazyFormColorPickerLightvueMixins, LazyFormColorPickerLightvueUtils, LazyFormColorPickerLvColorPicker, LazyFormColorPickerOverlayPanel, LazyFormColorPickerSaturation, LazyFormColorPickerTinycolor2, LazyFormDateInput, LazyFormDatePicker, LazyFormDatetimePicker, LazyFormDropzone, LazyFormInput, LazyFormSelect, LazyFormSwitch, LazyFormTextarea, LazyFormTimeInput, LazyFormTimePicker, LazyIncomesForm, LazyLibraryMediaCollectionsFormCollectionMedia, LazyLibraryMediaCollectionsFormCustomers, LazyLibraryMediaCollectionsFormInfo, LazyLibraryMediaCollectionsRow, LazyLibraryMediaForm, LazyLoader, LazyMaskedImage, LazyMediaConsentModal, LazyMediaCustomers, LazyMediaShow, LazyModal, LazyModalsAppointmentModal, LazyModalsClassDetailsModal, LazyModalsCustomerIncomesModal, LazyModalsEvaluationsAlertModal, LazyModalsSubscriptionModal, LazyModalsWagesModal, LazyNumbersCircledValue, LazyNumbersLabelledValue, LazyPagination, LazyServicesForm, LazySidebar, LazySubscriptionsData, LazySubscriptionsFormAppointments, LazySubscriptionsFormBook, LazySubscriptionsFormInfo, LazySubscriptionsFormPayments, LazyTrainerWagesMonth, LazyTrainerWagesYear, LazyTrainersBadge, LazyTrainersDaySlotForm, LazyTrainersFormAvailabilities, LazyTrainersFormHistoric, LazyTrainersFormInfo, LazyTrainersFormManual, LazyTrainersFormMonthlyBonuses, LazyTrainersFormServices, LazyWeekDayTime, LazyXlsButton } from '#components'
const lazyGlobalComponents = [
  ["Accordion", LazyAccordion],
["AccountsForm", LazyAccountsForm],
["AppointmentsCustomerDetails", LazyAppointmentsCustomerDetails],
["AppointmentsDateTime", LazyAppointmentsDateTime],
["CalendarDay", LazyCalendarDay],
["CalendarWeek", LazyCalendarWeek],
["ChartsBar", LazyChartsBar],
["ChartsIncomesBar", LazyChartsIncomesBar],
["ChartsIncomesLine", LazyChartsIncomesLine],
["ChartsLine", LazyChartsLine],
["ChartsPie", LazyChartsPie],
["ClassCalendarsShow", LazyClassCalendarsShow],
["ClassSubscriptionsForm", LazyClassSubscriptionsForm],
["ClassTypesForm", LazyClassTypesForm],
["CompletionBar", LazyCompletionBar],
["CustomersAlertBadges", LazyCustomersAlertBadges],
["CustomersFormInfo", LazyCustomersFormInfo],
["CustomersFormLongTermAppointments", LazyCustomersFormLongTermAppointments],
["CustomersFormSubscriptions", LazyCustomersFormSubscriptions],
["CustomersMonth", LazyCustomersMonth],
["CustomersYear", LazyCustomersYear],
["Flash", LazyFlash],
["FormColorPickerAlpha", LazyFormColorPickerAlpha],
["FormColorPickerCheckboard", LazyFormColorPickerCheckboard],
["FormColorPickerClamp", LazyFormColorPickerClamp],
["FormColorPickerColor", LazyFormColorPickerColor],
["FormColorPickerCore", LazyFormColorPickerCore],
["FormColorPickerEditInput", LazyFormColorPickerEditInput],
["FormColorPickerHue", LazyFormColorPickerHue],
["FormColorPickerLightvueMixins", LazyFormColorPickerLightvueMixins],
["FormColorPickerLightvueUtils", LazyFormColorPickerLightvueUtils],
["FormColorPickerLvColorPicker", LazyFormColorPickerLvColorPicker],
["FormColorPickerOverlayPanel", LazyFormColorPickerOverlayPanel],
["FormColorPickerSaturation", LazyFormColorPickerSaturation],
["FormColorPickerTinycolor2", LazyFormColorPickerTinycolor2],
["FormDateInput", LazyFormDateInput],
["FormDatePicker", LazyFormDatePicker],
["FormDatetimePicker", LazyFormDatetimePicker],
["FormDropzone", LazyFormDropzone],
["FormInput", LazyFormInput],
["FormSelect", LazyFormSelect],
["FormSwitch", LazyFormSwitch],
["FormTextarea", LazyFormTextarea],
["FormTimeInput", LazyFormTimeInput],
["FormTimePicker", LazyFormTimePicker],
["IncomesForm", LazyIncomesForm],
["LibraryMediaCollectionsFormCollectionMedia", LazyLibraryMediaCollectionsFormCollectionMedia],
["LibraryMediaCollectionsFormCustomers", LazyLibraryMediaCollectionsFormCustomers],
["LibraryMediaCollectionsFormInfo", LazyLibraryMediaCollectionsFormInfo],
["LibraryMediaCollectionsRow", LazyLibraryMediaCollectionsRow],
["LibraryMediaForm", LazyLibraryMediaForm],
["Loader", LazyLoader],
["MaskedImage", LazyMaskedImage],
["MediaConsentModal", LazyMediaConsentModal],
["MediaCustomers", LazyMediaCustomers],
["MediaShow", LazyMediaShow],
["Modal", LazyModal],
["ModalsAppointmentModal", LazyModalsAppointmentModal],
["ModalsClassDetailsModal", LazyModalsClassDetailsModal],
["ModalsCustomerIncomesModal", LazyModalsCustomerIncomesModal],
["ModalsEvaluationsAlertModal", LazyModalsEvaluationsAlertModal],
["ModalsSubscriptionModal", LazyModalsSubscriptionModal],
["ModalsWagesModal", LazyModalsWagesModal],
["NumbersCircledValue", LazyNumbersCircledValue],
["NumbersLabelledValue", LazyNumbersLabelledValue],
["Pagination", LazyPagination],
["ServicesForm", LazyServicesForm],
["Sidebar", LazySidebar],
["SubscriptionsData", LazySubscriptionsData],
["SubscriptionsFormAppointments", LazySubscriptionsFormAppointments],
["SubscriptionsFormBook", LazySubscriptionsFormBook],
["SubscriptionsFormInfo", LazySubscriptionsFormInfo],
["SubscriptionsFormPayments", LazySubscriptionsFormPayments],
["TrainerWagesMonth", LazyTrainerWagesMonth],
["TrainerWagesYear", LazyTrainerWagesYear],
["TrainersBadge", LazyTrainersBadge],
["TrainersDaySlotForm", LazyTrainersDaySlotForm],
["TrainersFormAvailabilities", LazyTrainersFormAvailabilities],
["TrainersFormHistoric", LazyTrainersFormHistoric],
["TrainersFormInfo", LazyTrainersFormInfo],
["TrainersFormManual", LazyTrainersFormManual],
["TrainersFormMonthlyBonuses", LazyTrainersFormMonthlyBonuses],
["TrainersFormServices", LazyTrainersFormServices],
["WeekDayTime", LazyWeekDayTime],
["XlsButton", LazyXlsButton],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
